import ChiefComplaintQuestionMixin from '@/Mixins/BaseInformation/ChiefComplaint/Question.mixin';
import ChiefComplaintAnswerMixin from '@/Mixins/BaseInformation/ChiefComplaint/Answer.mixin';
import SharedHelper from '../../Shared';

export default {
  mixins: [ChiefComplaintQuestionMixin, ChiefComplaintAnswerMixin, SharedHelper],
  data() {
    return {
      currentSection: 0,
      isAttachmentModalOpen: false,
      selectedNurseDiagnoses: [],
      currentNurseDiagnos: {},
      currentNurseDiagnosId: 0,
      selectedQuestions: [],
      selectedAnswers: [],
      answerRanks: [
        {
          rank: 3,
          color: '#FFAFAF',
        },
        {
          rank: 2,
          color: '#FFE290',
        },
        {
          rank: 1,
          color: '#A4FFCB',
        },
        {
          rank: 0,
          color: '#F4F4F4',
        },
      ],
      selectedTriageImgSrc: '',
    };
  },
  methods: {
    // attachment-Modal
    openAttachmentModal: function () {
      this.isAttachmentModalOpen = true;
    },
    closeAttachmentModal: function () {
      this.isAttachmentModalOpen = false;
    },
    selectTriageImg: function (imgSrc) {
      this.selectedTriageImgSrc = imgSrc;
    },
    isSelectedTriageImg: function (imgSrc) {
      return this.selectedTriageImgSrc === imgSrc;
    },
    getRelatedAnswersQuestions: function (id) {
      this.getAllActiveQuestionHandler(id);
      this.getAllActiveAnswersHandler(id);
    },
    selectCurrentNurseDiagnos: function (item) {
      this.currentNurseDiagnos = item;
    },
    onChiefComplaintChange: function (item) {
      if ([...this.selectedNurseDiagnoses].some(({ id }) => item?.id === id)) {
        this.addNestedNurseDiagnos(item);
      } else this.selectCurrentNurseDiagnos(item);
    },
    addToSelectedNurseDiagnoses: function (item) {
      this.selectedNurseDiagnoses = [...this.selectedNurseDiagnoses, item];
    },
    selectFromCurrentNurseDiagnoses: function (itemId) {
      const selctedItem = [...this.selectedNurseDiagnoses].find(({ id }) => itemId === id);
      this.selectCurrentNurseDiagnos(selctedItem);
    },
    haveSameNurseDiagnos: function (item) {
      return [...this.selectedNurseDiagnoses].some((nurseDiagnos) => nurseDiagnos.id === item.id);
    },
    addNestedNurseDiagnos: function (item) {
      if (!this.haveSameNurseDiagnos(item)) this.addToSelectedNurseDiagnoses(item);
      else {
        const itemIndex = [...this.selectedNurseDiagnoses].findIndex(({ id }) => id === item?.id);
        this.currentNurseDiagnosId = itemIndex;
      }
      this.selectCurrentNurseDiagnos(item);
    },
    haveShownRank: function (itemRank) {
      return [...this.allActiveAnswersList].some(({ rank }) => rank === itemRank);
    },
    closeNewHandleForm: function () {
      this.cleanForm();
      this.changePageTitle(this.pageTtile);
      if (this.type == "hand") {
        this.$root.$refs.Home.closeForm(this.uniqueId);
      }
    },
    changePageTitle: function (title) {
      document.title = title;
    },
    initialPageTitle: function () {
      this.pageTtile = document.title;
      this.changePageTitle('تماس جدید');
    },
  },
  computed: {
    haveOnlyAttachments: function () {
      return (
        ![...this.allActiveQuestionsList]?.length &&
        this.allAttachments?.length &&
        this.currentSection === 0 &&
        !this.load.val
      );
    },
  },
  watch: {
    selectedNurseDiagnoses: function (currentVal) {
      const lastIndex = currentVal?.length - 1;
      this.currentNurseDiagnosId = lastIndex;
    },

    currentNurseDiagnos: function (currentVal) {
      if (currentVal?.id) {
        this.setAllAttachments([]);
        this.getRelatedAnswersQuestions(currentVal?.id);
        this.getAllChiefComplaintAttchments(currentVal?.id);
        // this.$store.dispatch('setCurrentNurseDiagnosis', currentVal);
        try {
          this.selectedNurseDesition = currentVal
        } catch (error) {
          console.log("error selectedNurseDesition : ", error);
        }
      }
      if (!this.haveSameNurseDiagnos(currentVal)) this.addToSelectedNurseDiagnoses(currentVal);
    },
    haveOnlyAttachments: function (currentVal) {
      if (currentVal) {
        this.openAttachmentModal();
      } else this.closeAttachmentModal();
    },
    allAttachments: function (currentVal) {
      if (currentVal?.length > 0) this.selectTriageImg(currentVal[0]?.filePath);
    },
    selectedAnswers: function (currentVal) {
      // this.$store.dispatch('setSelectedTriageAnswersDispatch', currentVal);
      this.setMissionRankBaseOnTriageAnswers(currentVal)
    },
  },
};
